/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IMedicine } from 'app/shared/model/medicine.model';
import { IMedicationSchedule } from 'app/shared/model/medication-schedule.model';
import { ITemplateMedication } from 'app/shared/model/template-medication.model';

export interface ITemplateSchedule {
  id?: string;
  dose?: string;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  medicine?: IMedicine;
  schedule?: IMedicationSchedule;
  medication?: ITemplateMedication;
}

export const defaultValue: Readonly<ITemplateSchedule> = {
  active: false,
};
